import React from 'react'
import { Box, Typography } from '@mui/material'
import LoginForm from '../components/forms/LoginForm'
import CenteredContainer from '../components/ui/CenteredContainer'
import { useAuth } from '../hooks/context/UserAuthContext'
import { Navigate, useLocation } from 'react-router-dom'

const Login = () => {
  const { user } = useAuth()
  const { state } = useLocation()
  if (user) {
    return <Navigate to={state?.from || '/dashboard'} />
  }
  return (
    <CenteredContainer maxWidth='sm' sx={{ py: 2 }}>
      <Box mb={2}>
        <Typography variant='h5'>Login</Typography>
      </Box>
      <LoginForm />
    </CenteredContainer>
  )
}

export default Login
